<template>
    <h2 class="page-header">
        <span>{{ headerTitle }}</span>
        <span class="sub_title">{{ headerSubtitle }}</span>
    </h2>
</template>

<script>
    export default {
        name: 'HeaderTitle',

        data: function () {
            return {
                'headerTitle': 'OMK',
                'headerSubtitle': 'Service'
            }
        }
    }
</script>
<style scoped>
    .sub_title {
        font-size: 70%;
        color: rgba(0, 0, 0, 0.5);
    }
    .page-header {
        font-size: 50px;
        font-weight: 800;
        margin-left: 20px;
        color: rgba(0, 0, 0, 0.9);
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/HeaderTitle.vue